/* SeatFit rules for the products sold without seat sets: car covers (kind 'cover') and floor mats ('mat').
 * Loaded `defer` by snippets/seatfit-config.liquid after seatfit-core-resolve.js and before seatfit-core-rules.js,
 * whose stepsFor() hands every finished vehicle row of these kinds to finishKindSelection(). offer() and tiersFor()
 * turn a selection or a vehicle into what to buy and what it costs, from the price tiers of the kind's index. */
(function () {
  'use strict';
  var SF = window.SeatFit;
  if (!SF) { console.warn('[SeatFit] seatfit-core.js must load before seatfit-core-cover-mat-rules.js'); return; }
  if (SF.offer) return; // second copy of the tag

  // The mats' set is a step of their vehicle data, yet it picks the product: it selects the "Floor Mat Set"
  // option and stays out of the Vehicle line in the cart.
  var OPTION_STEP = { mat: 'floor-mat-set' };

  function has(obj, key) { return !!obj && Object.prototype.hasOwnProperty.call(obj, key); }
  function money(v) { return typeof v === 'number' && isFinite(v) ? v : null; }

  // 'seat' | 'cover' | 'mat'; resolve() marks only the kinds sold without seat sets.
  function kindOf(ctx) { return (ctx && ctx.kind) || 'seat'; }

  function isOptionStep(ctx, stepName) {
    var want = has(OPTION_STEP, kindOf(ctx)) ? OPTION_STEP[kindOf(ctx)] : '';
    return !!want && SF.slugify(stepName) === want;
  }

  // Step names (slugs) of a vehicle in asking order, for stepsFor() to walk by name. Every row keeps its own order:
  // on Silverado 2024 mats Cab comes before Floor Mat Set although the EV row, listed first, has only the set.
  // Otherwise first seen goes first, which also settles rows that contradict each other (Sierra 2016 mats ask
  // Shifter Type before Console Type in one row and after it in another). URL keys follow this order.
  function stepOrder(rows) {
    var seen = [];
    var before = {};
    (rows || []).forEach(function (r) {
      var prev = [];
      (r.st || []).forEach(function (p) {
        var s = p && SF.slugify(p[0]);
        if (!s) return;
        if (!has(before, s)) { before[s] = {}; seen.push(s); }
        prev.forEach(function (q) { if (q !== s) before[s][q] = true; });
        prev.push(s);
      });
    });
    var order = [];
    var placed = function (s) { return order.indexOf(s) >= 0; };
    while (order.length < seen.length) {
      var left = seen.filter(function (s) { return !placed(s); });
      order.push(left.filter(function (s) { return Object.keys(before[s]).every(placed); })[0] || left[0]);
    }
    return order;
  }

  // Covers: a row sells some colours only (row.c: colour slug -> price tier). A colour it lacks is no mistake of
  // the shopper, so the selection stays open on 'color' and the buy box switches to a colour the row sells.
  // Mats: every step answered (the set included) is the whole choice.
  function finishKindSelection(out, ctx, picks) {
    if (kindOf(ctx) === 'cover') {
      out.colors = Object.keys((out.row && out.row.c) || {});
      var want = SF.slugify(picks && picks.color);
      out.color = out.colors.indexOf(want) >= 0 ? want : null;
      if (!out.color) out.missing = { kind: 'color', name: 'Color', key: 'color' };
    }
    out.complete = !out.missing;
    return out;
  }

  // {tier, price, compareAt} from the index tiers ({"A": [price, compare-at price]}); null for an unknown tier.
  function tierPrice(ctx, tier) {
    var p = has(ctx && ctx.tiers, tier) ? ctx.tiers[tier] : null;
    return p ? { tier: tier, price: money(p[0]), compareAt: money(p[1]) } : null;
  }

  // What a finished selection buys: the Shopify option values that pick its variant, keys in click order (covers
  // {Size}; mats {"Floor Mat Set", Size}), plus its tier and price. names = {set, size}: option names from the block
  // settings. null while the selection is open, for seats, or when the data lacks the tier or the set step.
  function offer(ctx, sel, names) {
    var kind = kindOf(ctx);
    var row = sel && sel.complete ? sel.row : null;
    if (!row || kind === 'seat') return null;
    names = names || {};
    var options = {};
    if (kind === 'mat') {
      var step = (row.st || []).filter(function (p) { return p && isOptionStep(ctx, p[0]); })[0];
      if (!step || !step[1]) return null;
      options[names.set || 'Floor Mat Set'] = step[1];
    }
    var tier = kind === 'cover' ? (row.c || {})[sel.color] : row.t;
    if (!tier) return null;
    options[names.size || 'Size'] = tier;
    return Object.assign({ options: options }, tierPrice(ctx, tier) || { tier: tier, price: null, compareAt: null });
  }

  // Every tier the vehicle sells (all rows of the context, or the rows given; every colour of a cover row),
  // cheapest first: [{tier, price, compareAt}]. A cross-sell card shows the first as its price. [] for seats.
  function tiersFor(ctx, rows) {
    var seen = {};
    var out = [];
    (rows || (ctx && ctx.rows) || []).forEach(function (r) {
      var tiers = r && r.c ? Object.keys(r.c).map(function (k) { return r.c[k]; }) : [r && r.t];
      tiers.forEach(function (t) {
        var p = t && !has(seen, t) ? tierPrice(ctx, t) : null;
        if (p) { seen[t] = true; out.push(p); }
      });
    });
    return out.sort(function (a, b) { return (a.price == null) - (b.price == null) || a.price - b.price; });
  }

  Object.assign(SF, { kindOf: kindOf, isOptionStep: isOptionStep, stepOrder: stepOrder,
    finishKindSelection: finishKindSelection, tierPrice: tierPrice, offer: offer, tiersFor: tiersFor });
})();
